<template>
  <div id="footer" class="container-fluid">
    <p class="address_tel_fax">
      <span>健康游戏忠告： 抵制不良游戏 拒绝盗版游戏 注意自我保护 谨防受骗上当 适度游戏益脑 沉迷游戏伤身 合理安排时间 享受健康生活</span>
    </p>
    <p class="email_wx">
      <span><a href="https://beian.miit.gov.cn/" target="_blank">蜀ICP备2025138577号-2</a></span>
      <span><a href="https://beian.mps.gov.cn/#/query/webSearch?code=51019002007996" target="_blank">川公网安备51019002007996号</a></span>
    </p>
    <p class="email_wx">
      服务专用邮箱：kefu@luckymj.cn 7x24小时为您服务
    </p>
    <p class="copy">Copyright &copy; 2025 幸运麻将</p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 200px;
  color: #fff;
  background: #474747;
  text-align: center;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 20px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0 10px;
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue